/* React */
import React, { useState } from "react";

/* Swiper */
import {
  Swiper,
  SwiperClass,
  SwiperSlide,
} from "swiper/react";

import SwiperControls from "src/components/shared/swiper/swiper-controls/SwiperControls";

/* Stylesheet */
import styles from "./SwiperWrapper.module.scss";

/* Interfaces */
interface SwiperWrapperProps<T> {
  scssProps?: ScssProps;
  label?: string;
  data: T[];
  handleActiveIndex?: (index: number) => void;
  renderItem: (item: T, index: number) => React.ReactNode;
  pagination?: React.ReactNode;
  disabled?: DisabledProps;
  currentPage?: number;
  options?: OptionProps;
  handlePrevPage?: () => void;
  handleNextPage?: () => void;
}

interface ScssProps {
  backgroundColor?: string;
}

interface DisabledProps {
  prevDisabled: boolean;
  nextDisabled: boolean;
}

interface OptionProps {
  spaceBetween?: number;
}

const SwiperWrapper = <T,>({
  scssProps,
  label,
  data,
  handleActiveIndex,
  renderItem,
  pagination,
  options,
  handlePrevPage,
  handleNextPage,
}: SwiperWrapperProps<T>) => {
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [swiperInstance, setSwiperInstance] =
    useState<SwiperClass | null>(null);

  return (
    <>
      <Swiper
        onSwiper={setSwiperInstance}
        className={styles.swiper}
        spaceBetween={options?.spaceBetween || 0}
        onSlideChange={(swiper) => {
          setActiveIndex(swiper.activeIndex);
          handleActiveIndex?.(swiper.activeIndex);
        }}
      >
        {data.map((item, index) => {
          return (
            <SwiperSlide
              key={index}
              className={styles.swiper_slide}
            >
              {renderItem(item, index)}
            </SwiperSlide>
          );
        })}
      </Swiper>
      <SwiperControls
        scssProps={scssProps}
        name={label}
        swiperInstance={swiperInstance}
        stacked={true}
        length={data.length}
        activeIndex={activeIndex}
        pagination={pagination}
        handlePrevPage={handlePrevPage}
        handleNextPage={handleNextPage}
      />
    </>
  );
};

export default SwiperWrapper;
